import { useCallback, useRef } from "react";
import { useTranslation } from "react-i18next";
import { DirectionsCar } from "@mui/icons-material";
import { Button } from "@mui/material";
import { FormikProps, useFormikContext } from "formik";

import { useAppDialog } from "hooks/useAppDialog";
import { FormValues } from "../../EditUserForm";
import { AddPlateForm, PlateValues } from "./AddPlateForm";

export const AddPlates = (): JSX.Element => {
  const { values, setFieldValue } = useFormikContext<FormValues>();
  const { t } = useTranslation();
  const { openDialog, Dialog, dialogProps, closeDialog } = useAppDialog();

  const formRef = useRef<FormikProps<PlateValues>>(null);

  const onSubmit = useCallback(() => {
    return formRef.current?.handleSubmit();
  }, [formRef]);

  const addNewPlate = useCallback(
    (certification) => {
      setFieldValue("certifications", [
        ...values.certifications,
        certification,
      ]);
      closeDialog();
    },
    [setFieldValue, values, closeDialog]
  );

  return (
    <>
      <Button
        variant="contained"
        startIcon={<DirectionsCar fontSize="small" />}
        onClick={openDialog}
      >
        {t("NewPlate")}
      </Button>
      <Dialog
        {...dialogProps}
        title={t("NewPlate")}
        loading={false}
        onSubmit={onSubmit}
        actionText={t("Assign")}
        maxWidth="md"
      >
        <AddPlateForm formRef={formRef} onSubmit={addNewPlate} />
      </Dialog>
    </>
  );
};
